import { createFileRoute, redirect } from '@tanstack/react-router'

// The README of @uptrack-app/mcp named this address, and MCP directories copied it. It was a 404.
export const Route = createFileRoute('/guides_/install-in-your-ai')({
  beforeLoad: () => {
    throw redirect({ to: '/guides/mcp', statusCode: 301 })
  },
  component: () => null,
})
